import axios from 'axios';
const apiUrl = process.env.VUE_APP_API_VIDA_URL;
import usersUtils from '../utils/user';

export default {
  async reprocessPayment(purchaseId, paymentMethodId) {
    try {
      const response = await axios.post(
        `${apiUrl}/payments/${purchaseId}/reprocess`,
        { paymentMethodId },
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
